import React from "react";
import TagsInput from "react-tagsinput";
import cx from "clsx";
import styles from "./styles.module.scss";
import { Button } from "../../../../../shared/Button/Button";
import { CircularProgress } from "../../../../../shared/CircularProgress/CircularProgress";
import { useEmails } from "./hooks/useEmails";
import { useSubmit } from "./hooks/useSubmit";

export const LeadsEmailForwarding = () => {
  const { emails, setEmails, isEmailsLoading } = useEmails();
  const submit = useSubmit();

  return (
    <div className="setting-setion m-b-15">
      <div className="membershipSectionTitle">
        Set Up Email Forwarding for New Leads
      </div>
      <div className={cx("wallet-edit-block", styles.content)}>
        <div className={styles.left}>
          <div className={styles.innerLeft}>
            <div className="newInputFileldOuter">
              <div className={cx("newInputLabel", styles.inputLabel)}>
                Notification Email
              </div>
              <div className="simpleInput div-email-tag-input auto-height p-t-5">
                <TagsInput
                  value={emails}
                  onChange={setEmails}
                  disabled={isEmailsLoading}
                  addOnBlur={true}
                  addKeys={[9, 13, 32]}
                  onlyUnique={true}
                  inputProps={{
                    className: "react-tagsinput-input",
                    placeholder: "Add emails...",
                  }}
                />
              </div>
            </div>
          </div>
          <div className={cx(styles.innerRight, styles.hint)}>
            Emails are sent when a new lead is submitted to Aesthetic Record and
            will contain the name, email and phone number as provided per lead.
          </div>
        </div>
        <Button
          size="small"
          className={styles.save}
          onClick={() => submit.initiate(emails)}
          isDisabled={submit.isLoading || isEmailsLoading}
          leftAdornment={
            submit.isLoading ? (
              <CircularProgress size="tiny" color="white" />
            ) : undefined
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};
